/* TAPE! header (Phase 3A): navigation dropdowns, mobile drawer, predictive search combobox and wishlist count. */
(function () {
  'use strict';

  /* Dropdowns: disclosure buttons. Escape or a click outside closes them. */
  var toggles = Array.prototype.slice.call(document.querySelectorAll('[data-tape-menu-toggle]'));
  function closeMenus(except) {
    toggles.forEach(function (t) {
      if (t === except) return;
      t.setAttribute('aria-expanded', 'false');
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = true;
    });
  }
  toggles.forEach(function (t) {
    var panel = document.getElementById(t.getAttribute('aria-controls'));
    t.addEventListener('click', function () {
      var open = t.getAttribute('aria-expanded') !== 'true';
      closeMenus(t);
      t.setAttribute('aria-expanded', String(open));
      if (panel) panel.hidden = !open;
    });
    t.parentElement.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && t.getAttribute('aria-expanded') === 'true') {
        closeMenus();
        t.focus();
      }
    });
    t.parentElement.addEventListener('focusout', function (ev) {
      if (ev.relatedTarget && !t.parentElement.contains(ev.relatedTarget)) {
        t.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      }
    });
  });
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest || !ev.target.closest('.tape-primary__item')) closeMenus();
  });

  /* Drawer: native modal dialog gives the focus trap, Escape and focus return. */
  var drawer = document.querySelector('[data-tape-drawer]');
  if (drawer && typeof drawer.showModal === 'function') {
    var openers = Array.prototype.slice.call(document.querySelectorAll('[data-tape-drawer-open]'));
    function syncExpanded() {
      openers.forEach(function (o) { o.setAttribute('aria-expanded', String(drawer.open)); });
    }
    openers.forEach(function (b) {
      b.addEventListener('click', function () { drawer.showModal(); });
    });
    /* The `close` event is not guaranteed to fire after Escape, so follow the `open` attribute instead. */
    new MutationObserver(syncExpanded).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    drawer.addEventListener('close', syncExpanded);
    drawer.querySelector('[data-tape-drawer-close]').addEventListener('click', function () { drawer.close(); });
    drawer.addEventListener('click', function (ev) { if (ev.target === drawer) drawer.close(); });
  }

  /* Wishlist count from first-party TapeWishlist (falls back quietly if unavailable). */
  var wishCount = document.querySelector('[data-tape-wish-count]');
  var wishLink = document.querySelector('[data-tape-wishlist]');
  function showWishCount(n) {
    if (!wishCount) return;
    wishCount.hidden = !(n > 0);
    wishCount.textContent = n > 0 ? String(n) : '';
    if (wishLink) wishLink.setAttribute('aria-label', n > 0 ? 'Wishlist, ' + n + (n === 1 ? ' item' : ' items') : 'Wishlist');
  }
  function refreshWishCount() {
    try {
      if (window.TapeWishlist && typeof window.TapeWishlist.read === 'function') {
        showWishCount((window.TapeWishlist.read().items || []).length);
      }
    } catch (e) { /* leave hidden */ }
  }
  refreshWishCount();
  window.addEventListener('tape:wishlist:change', refreshWishCount);

  /* Predictive search: ARIA 1.2 combobox with a listbox popup, fed by Shopify's /search/suggest. */
  if (customElements.get('tape-predictive-search')) return;
  customElements.define('tape-predictive-search', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('[data-tape-ps-input]');
      this.panel = this.querySelector('[data-tape-ps-panel]');
      this.list = this.querySelector('[data-tape-ps-list]');
      this.status = this.querySelector('[data-tape-ps-status]');
      this.options = [];
      this.active = -1;
      this.cache = {};
      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.search(), 220);
      });
      this.input.addEventListener('keydown', (ev) => this.onKey(ev));
      this.input.addEventListener('focus', () => { if (this.input.value.trim() && this.list.children.length) this.open(); });
      this.list.addEventListener('mousedown', (ev) => ev.preventDefault());
      document.addEventListener('click', (ev) => { if (!this.contains(ev.target)) this.close(); });
      this.form.addEventListener('submit', (ev) => {
        if (!this.input.value.trim()) { ev.preventDefault(); this.input.focus(); }
      });
    }

    search() {
      const q = this.input.value.trim();
      if (!q) { this.close(); this.list.innerHTML = ''; this.status.textContent = ''; return; }
      if (this.cache[q]) { this.render(this.cache[q]); return; }
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      const url = base + '?q=' + encodeURIComponent(q) +
        '&resources[type]=query,product,collection,article,page&resources[limit]=5&resources[limit_scope]=each' +
        '&resources[options][prefix]=last&section_id=' + encodeURIComponent(this.dataset.sectionId);
      fetch(url, { signal: this.controller.signal })
        .then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const res = doc.getElementById('tape-ps-results');
          const html = res ? res.innerHTML : '';
          this.cache[q] = html;
          if (this.input.value.trim() === q) this.render(html);
        })
        .catch((e) => {
          if (e.name === 'AbortError') return;
          this.close();
          this.status.textContent = 'Suggestions are unavailable. Press Enter to search.';
        });
    }

    render(html) {
      const pid = this.list.id;
      this.list.innerHTML = html;
      this.options = Array.prototype.slice.call(this.list.querySelectorAll('[role="option"]'));
      this.list.querySelectorAll('[id^="tape-ps-g-"]').forEach((el) => {
        const id = pid + '-' + el.id;
        const group = this.list.querySelector('[aria-labelledby="' + el.id + '"]');
        el.id = id;
        if (group) group.setAttribute('aria-labelledby', id);
      });
      this.options.forEach((o, i) => { o.id = pid + '-opt-' + i; });
      this.active = -1;
      this.input.removeAttribute('aria-activedescendant');
      if (!this.options.length) { this.close(); return; }
      this.open();
      const n = this.options.filter((o) => !o.hasAttribute('data-tape-ps-all')).length;
      this.status.textContent = n
        ? n + (n === 1 ? ' suggestion' : ' suggestions') + '. Use the up and down arrows to browse.'
        : 'No suggestions. Press Enter to search.';
    }

    open() {
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.options.forEach((o) => o.setAttribute('aria-selected', 'false'));
      this.active = -1;
    }

    move(delta) {
      if (!this.options.length) return;
      this.active += delta;
      if (this.active < 0) this.active = this.options.length - 1;
      if (this.active >= this.options.length) this.active = 0;
      this.options.forEach((o, i) => o.setAttribute('aria-selected', i === this.active ? 'true' : 'false'));
      const el = this.options[this.active];
      this.input.setAttribute('aria-activedescendant', el.id);
      el.scrollIntoView({ block: 'nearest' });
    }

    onKey(ev) {
      if (ev.key === 'ArrowDown') {
        ev.preventDefault();
        if (this.panel.hidden) { if (this.options.length) this.open(); else this.search(); return; }
        this.move(1);
      } else if (ev.key === 'ArrowUp') {
        if (this.panel.hidden) return;
        ev.preventDefault();
        this.move(-1);
      } else if (ev.key === 'Escape') {
        if (!this.panel.hidden) { ev.preventDefault(); this.close(); }
      } else if (ev.key === 'Enter' && !this.panel.hidden && this.active >= 0) {
        ev.preventDefault();
        const a = this.options[this.active].querySelector('a');
        if (a) window.location.href = a.href;
      } else if (ev.key === 'Tab') {
        this.close();
      }
    }
  });
})();
